import login from '@/locales/en/login.json'
import olkypass from '@/locales/en/pass.json'
import olkypay from '@/locales/en/pay.json'

export default {
  ...login,
  ...olkypass,
  ...olkypay
}
